import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { poService } from "../services/po.service";

export const createPO = createAsyncThunk("createPO", async (data, { rejectWithValue }) => {
    try {
        return await poService.createPO(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getPOList = createAsyncThunk("getPOList", async (params, { rejectWithValue }) => {
    try {
        return await poService.getPOList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getPO = createAsyncThunk("getPO", async (id, { rejectWithValue }) => {
    try {
        return await poService.getPO(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updatePO = createAsyncThunk("updatePO", async ({data, id}, { rejectWithValue }) => {
    try {
        return await poService.updatePO(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deletePO = createAsyncThunk("deletePO", async (id, { rejectWithValue }) => {
    try {
        return await poService.deletePO(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

const poSlice = createSlice({
    name: "pmo-po",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        detail: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        create: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        update: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        delete: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
    },
    reducers: {
        resetStatePO: (state) => {
            state.list.isError = false;
            state.list.message = null;
            state.detail.isError = false;
            state.detail.message = null;
            state.create.isError = false;
            state.create.message = null;
            state.create.data = null;
            state.update.isError = false;
            state.update.message = null;
            state.update.data = null;
            state.delete.isError = false;
            state.delete.message = null;
            state.delete.data = null;
        },
    },
    extraReducers: (builder) => {
        // get PO list
        builder.addCase(getPOList.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(getPOList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getPOList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload?.message;
        });

        // get PO detail
        builder.addCase(getPO.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getPO.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getPO.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload?.message;
        });

        // create PO
        builder.addCase(createPO.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createPO.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createPO.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload?.message;
        });

        // update PO
        builder.addCase(updatePO.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updatePO.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updatePO.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload?.message;
        });

        // delete PO
        builder.addCase(deletePO.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deletePO.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deletePO.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload?.message;
        });
    },
});

export default poSlice.reducer;
export const { resetStatePO } = poSlice.actions;

